import Button from '../Button'
import Heading from '../Heading'
import Img from '../Img'
import type { TArticleHeroProps } from './interface'

const ArticleHero = (props: TArticleHeroProps) => {
  const { title, heroImage, bgColor, shareWidget, parentLink, backLinkText } = props

  return (
    <div css={{ backgroundColor: `${bgColor}` }} tw="w-full pt-40">
      <Button
        icon="ArrowLeft"
        iconPosition="left"
        as="a"
        buttonStyle="hollow"
        href={`/${parentLink}/nos-articles`}
        tw="bg-transparent w-fit mx-auto text-primary-1"
      >
        <Heading tw="text-center" variant="h5" as="p">
          {backLinkText}
        </Heading>
      </Button>
      <div tw="flex flex-col text-center mx-6">
        <Heading variant="h1" as="h1" tw="mt-6 mb-11 font-semibold">
          {title}
        </Heading>
        <div tw="transform translate-y-56 lg:translate-y-14 -mt-56 lg:-mt-14 flex flex-col lg:flex-row mx-auto">
          <Img
            id={heroImage.id}
            alt={heroImage.description}
            filename={heroImage.filenameDownload}
            src={heroImage.src}
            width={660}
            height={660}
            tw="lg:[margin-left:calc(3.5rem + 64px)] aspect-square object-cover rounded"
          />
          <div tw="w-max mt-4 lg:mt-auto lg:ml-14">{shareWidget}</div>
        </div>
      </div>
    </div>
  )
}

export default ArticleHero
